module.exports = ".container {\n  padding-top: 3rem;\n  margin: auto;\n  text-align: center;\n}\n\na {\n  text-align: center;\n}\n\nmat-nav-list {\n  padding: 1em;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main